import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import SiteAssistant from './components/SiteAssistant';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Team from './pages/Team';
import Contact from './pages/Contact';
import News from './pages/News';
import Partnerships from './pages/Partnerships';
import Careers from './pages/Careers';
import Community from './pages/Community';
import Sitemap from './pages/Sitemap';
import GreatEmmanuelHospital from './pages/GreatEmmanuelHospital';
import './index.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
};

const App = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <ScrollToTop />
    <main className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/team" element={<Team />} />
        <Route path="/news" element={<News />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/community" element={<Community />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/great-emmanuel-hospital" element={<GreatEmmanuelHospital />} />
      </Routes>
    </main>
    <Footer />
    <SiteAssistant />
  </div>
);

export default App;
